<template>
  <div>
    <div class="tabs-bar" v-loading="loading">
      <div :class="`tabs-item ${planTime === `${data.year}-${String(index + 1).padStart(2, '0')}` ? 'active' : ''}`"
        v-for="(item, index) in 12"
        :key="index"
        @click="handleTabsClick(index + 1)">
        <span>{{ index + 1 }}月</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'time',
    event: 'input'
  },
  props: ['time', 'data'],
  data() {
    return {
      planTime: null,
      loading: false
    }
  },
  mounted() {
    this.addListener_refresh();
    this.init();
  },
  methods: {
    addListener_refresh() {
      this.$bus.$off('monthRefresh');
      this.$bus.$on('monthRefresh', _=>{
        this.$nextTick(_=>{
          this.init();
        })
      });
    },
    init() {
      // 默认展示当月
      let thisMonth = new Date().getMonth() + 1;
      let year = this.data.year;
      
      if(!this.planTime) {
        // 不是本年，默认展示1月份
        if(year !== new Date().getFullYear()) {
          thisMonth = 1;
        }
        this.updatePlanTime(`${year}-${String(thisMonth).padStart(2, '0')}`);
      } else {
        // 如果年份变化，重置月份
        let currentYear = this.planTime.split('-')[0];
        if(+currentYear !== year) {
          thisMonth = 1;
          this.updatePlanTime(`${year}-${String(thisMonth).padStart(2, '0')}`);
        }
      }
    },
    handleTabsClick(month) {
      let planTime = `${this.data.year}-${String(month).padStart(2, '0')}`;
      this.updatePlanTime(planTime);
      this.$emit('change', planTime);
    },
    updatePlanTime(data) {
      this.planTime = data;
      this.$emit('input', data);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .tabs-bar
    width 100%
    height auto 
    display flex
    justify-content flex-start
    align-items center
    margin-top 10px
    border-bottom 1px solid #eeeeee
    .tabs-item
      flex 1
      text-align center
      height 32px
      background #ffffff
      line-height 32px
      color #444
      position relative
      cursor pointer
      transition all linear .2s
      &:hover
        background rgb(240, 249, 235)
      &.active::after
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        content ""
        border-top 2px solid #67C23A
    .tabs-item+.tabs-item
      border-left 1px solid #eeeeee
</style>
